import { render, staticRenderFns } from "./TamanioForm.vue?vue&type=template&id=bfbebc50&scoped=true&"
import script from "./TamanioForm.vue?vue&type=script&lang=js&"
export * from "./TamanioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbebc50",
  null
  
)

export default component.exports